<template>
  <div class="single-offer">
    <div class="single-offer-top flex">
      <div class="single-offer-top-heading">
        <p class="heading-tiny line-height-small flex flex-wrap flex-align-items-center">
          <span class="offer-name mr-auto-md">{{ offer.name }}</span>
          <span class="ml-2 ml-0-md">
            <f-badge
              v-if="selectedProps.excludedBy"
              theme="danger"
              class="text-center">
              {{ $t('inquirySingleOffer.cannotBeCombinedWithSelectedOffer') }} <strong>{{ selectedProps.excludedBy }}</strong>
            </f-badge>
          </span>
        </p>
        <p
          v-if="offer.description"
          class="offer-description">
          {{ offer.description }}
        </p>
      </div>
      <div class="single-offer-top-actions flex flex-column">
        <div class="flex flex-align-items-center ml-auto">
          <f-button
            class="px-0"
            theme="text"
            @click.prevent="toggleDetailsShow">
            <span
              v-if="isDetailsVisible"
              v-pure-html="$t('inquirySingleOffer.hideDetailsOffer')">
            </span>
            <span
              v-else
              v-pure-html="$t('inquirySingleOffer.showDetailsOffer')">
            </span>
          </f-button>

          <template v-if="offerStatus === 'in-use'">
            <f-badge
              theme="success"
              class="ml-2">
              {{ $t('inquirySingleOffer.addedToOffer') }}
            </f-badge>
          </template>
          <template v-else>
            <f-button
              class="single-offer-action ml-2"
              :theme="addBtnTheme"
              :disabled="offerStatus === 'is-excluded' || offerStatus === 'in-use'"
              @click.prevent="selectOffer">
              <span
                v-if="offerStatus === 'is-added'"
                v-pure-html="$t('inquirySingleOffer.deleteFromOffer')">
              </span>
              <span
                v-else-if="offerStatus === 'is-excluded'">
                {{ $t('inquirySingleOffer.excluded') }}
              </span>
              <span
                v-else
                v-pure-html="$t('inquirySingleOffer.addToOffer')">
              </span>
            </f-button>
          </template>
        </div>
      </div>
    </div>

    <transition name="slide">
      <f-list
        v-if="isDetailsVisible"
        class="bank-offers-list mt-1"
        :loaded="true"
        :listSettings="listSettings"
        :listItems="[offer]"
        :isPlain="true"
        :isThSticky="false" />
    </transition>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'inquiry-single-offer',
  props: {
    listSettings: {
      required: true,
      type: Array
    },
    offer: {
      required: true,
      type: Object
    },
    offerVariantParent: {
      default: null,
      type: Object
    },
    selectedProps: {
      required: true,
      type: Object
    }
  },
  computed: {
    addBtnTheme () {
      if (this.offerStatus === 'in-use') {
        return 'warning';
      }

      if (this.offerStatus === 'is-excluded') {
        return 'primary';
      }

      if (this.offerStatus === 'is-available') {
        return 'primary';
      }

      if (this.offerStatus === 'is-added') {
        return 'danger'
      }

      return 'primary'
    },
    offerStatus () {
      if (this.selectedProps.disabled) {
        if (this.selectedProps.selected) {
          return 'in-use'
        }

        return 'is-excluded';
      }

      if (this.selectedProps.selected) {
        return 'is-added';
      }

      return 'is-available'
    }
  },
  data () {
    return {
      isDetailsVisible: false
    }
  },
  methods: {
    toggleDetailsShow () {
      Vue.set(this, 'isDetailsVisible', !this.isDetailsVisible);
    },
    selectOffer () {
      let offerID = this.offer.id;
      let variantID = null;
      if (this.offerVariantParent) {
        offerID = this.offerVariantParent.id;
        variantID = this.offer.id;
      }
      this.$bus.$emit('offer-selected', !this.selectedProps.selected, offerID, variantID);
    }
  }
}
</script>
